import { render, staticRenderFns } from "./supplierApproveMag.vue?vue&type=template&id=186423fd&scoped=true&"
import script from "./supplierApproveMag.vue?vue&type=script&lang=js&"
export * from "./supplierApproveMag.vue?vue&type=script&lang=js&"
import style0 from "./supplierApproveMag.vue?vue&type=style&index=0&id=186423fd&scoped=true&lang=css&"
import style1 from "./supplierApproveMag.vue?vue&type=style&index=1&id=186423fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186423fd",
  null
  
)

export default component.exports